import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-avatar-page-ui',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AvatarPageComponent {}
